<template>
  <div class="row mt-5">
    <div class="col-6">
      <SkillsDropdown @change="onSkillChange"></SkillsDropdown>
      <div class="table-responsive" v-if="categorySkillId">
        <table
          class="table table-row-dashed table-striped table-row-gray-300 align-middle"
        >
          <thead>
            <tr class="fw-bolder text-muted">
              <th class="min-w-50px w-175px px-9">Required skill</th>
              <th>Quantity</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="subSkill in subSkills" :key="subSkill.id">
              <td class="px-9">
                {{ subSkill.name }}
              </td>
              <td>
                <div
                  class="form-check form-switch form-check-custom form-check-solid"
                >
                  <input
                    class="form-control w-75px form-control-sm"
                    type="number"
                    @change="onChangeQtySubSkill($event, subSkill.id)"
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="col-6">
      <button class="btn btn-success w-100 h-40px" @click="handleBookButton">
        Book
      </button>
      <div class="table-responsive">
        <table
          class="table table-row-dashed table-striped table-row-gray-300 align-middle"
        >
          <thead>
            <tr class="fw-bolder text-muted">
              <th class="min-w-50px w-175px px-9">Required skill</th>
              <th>Quantity</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="subSkill in bookedSkills" :key="subSkill.id">
              <td class="px-9">
                {{ subSkill.name }}
              </td>
              <td>
                <div
                  class="form-check form-switch form-check-custom form-check-solid"
                >
                  <input
                    class="form-control w-75px form-control-sm"
                    type="number"
                    :value="subSkill.qty"
                    @change="onChangeQtySubSkill($event, subSkill.id)"
                  />
                </div>
              </td>
              <td>
                <button
                  @click="
                    $emit('deleteSkill', {
                      skillID: subSkill.id,
                      shiftID: localShiftID
                    })
                  "
                  class="btn btn-icon btn-bg-danger btn-active-color-light btn-sm me-1"
                >
                  <span class="svg-icon svg-icon-white svg-icon-3">
                    <inline-svg src="media/icons/duotone/General/Trash.svg" />
                  </span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import SkillsDropdown from "../dropdown/SkillsDropdown";
import { mapActions, mapGetters } from "vuex";
import _ from "lodash";

export default {
  name: "box-shift-slots",
  components: { SkillsDropdown },
  props: {
    selectedSkills: {
      type: Object,
      required: false
    },
    localShiftID: {
      typer: Number,
      required: true
    }
  },
  data() {
    return {
      categorySkillId: null,
      selectedSubSkills: {},
      bookedSkills: {},
    };
  },
  mounted() {
    if (this.selectedSkills) {
      this.bookedSkills = Object.assign({}, this.selectedSkills);
      this.selectedSubSkills = this.bookedSkills;
    }
    this.fetchDropdownData();
  },
  computed: {
    ...mapGetters("ListsModule", [
      "skills",
      "pms",
      "dresscodes",
      "companyCols"
    ]),
    subSkills() {
      if (!this.categorySkillId || !this.skills) return [];

      for (let i = 0; i < this.skills.length; i++) {
        if (this.skills[i].id === this.categorySkillId)
          return this.skills[i].children;
      }

      return [];
    },
    hasSelectedSkills() {
      return !_.isEmpty(this.selectedSubSkills);
    }
  },
  watch: {
    selectedSkills: {
      deep: true,
      handler(value) {
        if (value) {
          this.bookedSkills = Object.assign({}, value);
          this.selectedSubSkills = this.bookedSkills;
        }
      }
    },
    details: {
      deep: true,
      handler() {
        this.setDetails({
          id: this.localShiftID,
          details: this.details
        });
      }
    }
  },
  methods: {
    ...mapActions("ListsModule", ["fetchPms", "fetchDresscodes"]),
    fetchDropdownData() {
      this.fetchPms();
      this.fetchDresscodes();
    },
    onSkillChange(val) {
      this.selectedSubSkills = {};
      this.categorySkillId = val;
    },
    handleBookButton() {
      const bookedSkills = Object.assign(
        this.bookedSkills,
        this.selectedSubSkills
      );
      this.bookedSkills = bookedSkills;
      this.$emit("booked", bookedSkills);
    },
    getSkillData(skillId) {
      for (let i = 0; i < this.skills.length; i++) {
        if (this.skills[i].id === this.categorySkillId) {
          for (let j = 0; j < this.skills[i].children.length; j++) {
            console.log(this.skills[i].children[j].id, skillId);
            if (parseInt(this.skills[i].children[j].id) === skillId)
              return this.skills[i].children[j];
          }
        }
      }
    },
    onChangeQtySubSkill(event, skillId) {
      if (event.target.value > 0) {
        this.selectedSubSkills[skillId] = Object.assign(
          {
            qty: event.target.value
          },
          this.getSkillData(skillId)
        );
      } else {
        delete this.selectedSubSkills[skillId];
      }
    }
  }
};
</script>

<style scoped>
::placeholder {
  color: #c0c4cc;
}
</style>
